/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {useParameter} from "hooks/useParameter";
import React from "react";
import Strings from "toolbox/strings";
import useUserInfo from "authClient/useUserInfo";
import {ErrorBoundary} from "errorboundarys";
import SettingsMenuItem from "./SettingsMenuItem.jsx";


function SettingsBase({pages = []}) {
    let userInfo = useUserInfo()
    let userRole = userInfo?.role ?? "user"

    // only show the settings according to the role
    pages = pages.filter(page => {
        if (userRole === "admin") {
            return true;
        } else if (page.role === "admin") {
            return false;
        }
        return true;
    });

    let [menuItem, setMenuItem] = useParameter("menuItem");
    if (Strings.isEmpty(menuItem)) {
        menuItem = pages?.[0]?.id
    }


    let currentPage = pages.find(page => page.id === menuItem)

    function displayContent() {
        if (Strings.isEmpty(currentPage)) {
            return (<div>The {menuItem.toString()} Settings page could not be found.</div>)
        }

        return (<div className="py-6 px-4 sm:p-6 pb-8">
            <div>
                <h2 className="text-lg leading-6 font-medium text-gray-900">{currentPage?.title}</h2>
                <p className="mt-1 text-sm text-gray-500">
                    {currentPage?.description}
                </p>
            </div>
            <div className="mt-4">
                <ErrorBoundary>
                    {currentPage.content}
                </ErrorBoundary>
            </div>
        </div>)
    }

    return (<>
        <div className="divide-y divide-gray-200 grid grid-cols-12 h-full  divide-x"
             style={{minHeight: "85vh"}}>
            <aside className="pt-4 col-span-3 flex flex-col p-2">
                <nav className="space-y-2  grow">
                    {pages.map((page) => (
                        <SettingsMenuItem onClick={() => setMenuItem(page.id)} isSelected={menuItem === page.id}
                                          iconName={page.iconName}
                                          iconClass={page.iconClass}
                                          Name={page.title}/>
                    ))}
                </nav>
            </aside>
            <div className="divide-y divide-gray-200 col-span-9 overflow-y-auto customScrollbar">
                <ErrorBoundary>
                    {displayContent()}
                </ErrorBoundary>
            </div>
        </div>

    </>)

}

export default SettingsBase
